import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./pwa-install-bottom-sheet.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./pwa-install-bottom-sheet.component.scss?ngResource";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { AppConfig } from "../../../app.config";
let PwaInstallBottomSheetComponent = class PwaInstallBottomSheetComponent {
    bottomSheetRef;
    projectName;
    constructor(bottomSheetRef) {
        this.bottomSheetRef = bottomSheetRef;
        this.projectName = AppConfig.settings.projectSettings.projectName;
    }
    ngOnInit() {
    }
    install($event) {
        this.bottomSheetRef.dismiss(true);
    }
    dismiss($event) {
        this.bottomSheetRef.dismiss(false);
    }
    static ctorParameters = () => [
        { type: MatBottomSheetRef }
    ];
};
PwaInstallBottomSheetComponent = __decorate([
    Component({
        selector: "app-pwa-install-bottom-sheet",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], PwaInstallBottomSheetComponent);
export { PwaInstallBottomSheetComponent };
